<template>
  <div class="asc-plot-list-wrapper" data-automation-id="wrapper_plot_list">
    <div class="asc-plot-list-wrapper--text">
      <span
        >To preview and edit a saved plot, click into a plot title cell.</span
      >
    </div>
    <asc-plots-grid
      :values="savedPlots"
      :grid-filters="false"
      :deleting="deleting"
      :on-open-saved-plot="onOpenSavedPlot"
      :on-delete-saved-plot="onDeleteSavedPlot"
    ></asc-plots-grid>
  </div>
</template>

<script>
import AscPlotsGrid from '@/components/molecules/AscPlotsGrid'

export default {
  name: 'AscPlotListWrapper',

  components: {
    AscPlotsGrid,
  },

  props: {
    deleting: {
      type: Boolean,
      default: false,
    },
    savedPlots: {
      type: Array,
      default: () => [],
    },
    onOpenSavedPlot: {
      type: Function,
      default: () => {},
    },
    onDeleteSavedPlot: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-plot-list-wrapper {
  margin-top: 16px;

  .asc-plot-list-wrapper--text {
    margin-bottom: 32px;
    margin-top: -16px;
  }
}
</style>
